<template>
  <div class="dropdown-register-group-search-input">
    <i class="bx bx-search" />
    <input placeholder="Search message..." class="search-input" @input="handleOnChange" />
  </div>
</template>
<script>
export default {
  name: 'LineBroadcastSearchInput',
  methods: {
    handleOnChange(event) {
      const searchText = event.target.value.trim();
      this.$emit('on-change', searchText);
    },
  }
};
</script>
<style lang="scss" scoped>
.dropdown-register-group-search-input {
  height: 37;
  border-radius: 8px;
  padding: 8px 12px;
  background-color: #ffffff;
  border: 1px solid #dadce4;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  input {
    flex: 1;
    border: none;
    outline: none;
  }
  ::placeholder {
    color: #868ba6;
  }
  .bx {
    color: #868ba6;
    font-size: 20px;
  }
}
</style>
